/* eslint-disable */
const summerNoteSettings = {
  height: 300,
  placeholder: 'insert some text...',
  fontSizes: ['8', '10', '12', '14', '16','18', '24', '36', '48' , '64', '82', '150'],
  toolbar: [
    ['style', ['style','bold', 'italic','strikethrough', 'underline', 'clear']],
    ['insert', ['picture','link','hr']],
    ['fontsize', ['fontsize']],
    ['color', ['color']],
    ['para', ['ul', 'ol', 'paragraph']],
    ['height', ['height']],
    ['misc', ['codeview','undo','redo']],
  ],
  disableDragAndDrop: true,
  shortcuts: true,
};

export function initTextEditor(textEditor = 'summernote', settings = {}) {
  textEditor = `#${textEditor}`;
  $(textEditor).summernote({
    ...summerNoteSettings,
    ...settings,
    toolbar: [
      ...summerNoteSettings.toolbar,
      ...settings.toolbar || [],
    ]
  });
}


// WEBPACK FOOTER //
// ./src/components/summernote/summerNoteHelpers.js